import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store'; // Ensure you're importing your Vuex store

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import Dashboard from '@/views/Dashboard.vue';
import Login from '@/components/Login.vue';
// import Users from '@/views/Users.vue';
import Docs from '@/views/Docs.vue';
import CleaningItems from '@/views/CleaningItems.vue';
import Checklists from '@/views/mainpages/Checklists.vue';
import FireExtinguisherItems from '@/views/FireExtinguisherItems.vue';
import Restrooms from '@/views/mainpages/Restrooms.vue';
import FireExtinguisher from '@/views/mainpages/FireExtinguisher.vue';
import Groups from '@/views/mainpages/Groups.vue';
import MedicineCabinets from '@/views/mainpages/MedicineCabinets.vue';
import Room from '@/views/mainpages/Room.vue';
import Admin from '@/views/Admin.vue';
import ViewMedicineCabinet from '@/views/records/ViewMedicineCabinet.vue';
import ViewRoomTemperatureRecord from '@/views/records/ViewRoomTemperatureRecord.vue';
import ViewFireExtinguisher from '@/views/records/ViewFireExtinguisher.vue';
import ViewRestroomRecord from '@/views/records/ViewRestroomRecord.vue';
import Viewer from '@/views/Viewer.vue';
import GasPressureValue from '@/views/mainpages/GasPressureValue.vue';
import ViewGasPressureValue from '@/views/records/ViewGasPressureValue.vue';
import ViewDefibrillator from '@/views/records/viewDefibrillator.vue';
import DefibrillatorView from '@/views/mainpages/DefibrillatorView.vue';
import Settings from '@/views/mainpages/Settings.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: `เข้าสู่ระบบ`,
      // requiresGuest: true
    }
  },

  {
    path: '/viewer',
    component: Viewer,
    meta: {
      requiresAuth: false,
      title: 'Dashboard',
    },
    children: [
      {
        path: "",
        name: 'viewer',
        component: () => import('@/views/monitor/Monit.vue'),
        meta: {
          title: '',
        },
      },
      {
        path: "fire-extinguisher",
        name: 'pageFireExtinguisher',
        component: () => import('@/views/monitor/MonitFire.vue'),
        meta: {
          title: '',
        },
      },
      {
        path: "room-temperature",
        name: 'pageRoomTemperature',
        component: () => import('@/views/monitor/MonitRoom.vue'),
        meta: {
          title: '',
        },
      },
      {
        path: "medicine-cabinet",
        name: 'pageMedicineCabinet',
        component: () => import('@/views/monitor/MonitMedicineCabinet.vue'),
        meta: {
          title: '',
        },
      },
      {
        path: "restroom",
        name: 'pageRestroom',
        component: () => import('@/views/monitor/MonitRestroom.vue'),
        meta: {
          title: '',
        },
      },
      {
        path: "gas-pressure-value",
        name: 'pageGas',
        component: () => import('@/views/monitor/MonitGas.vue'),
        meta: {
          title: '',
        },
      },
    ]
  },
  {
    path: '/view-defibrillator/:code',
    name: 'ViewDefibrillator',
    component: ViewDefibrillator,
    props: true,
    meta: {
      title: `บันทึก Defibrillator`,
    }
  },

  {
    path: '/view-fire-extinguisher/:code',
    name: 'ViewFireExtinguisher',
    component: ViewFireExtinguisher,
    props: true,
    meta: {
      title: `บันทึก ถังดับเพลิง`,
    }
  },
  {
    path: '/view-medicine-cabinet/:code',
    name: 'ViewMedicineCabinet',
    component: ViewMedicineCabinet,
    props: true,
    meta: {
      title: `บันทึก ตู้แช่ยาและเวชภัณฑ์`,
    }
  },
  {
    path: '/view-room-temperature/:code',
    name: 'ViewRoomTemperatureRecord',
    component: ViewRoomTemperatureRecord,
    props: true,
    meta: {
      title: `บันทึก ห้องควบคุมอุณหภูมิ`,
    }
  },
  {
    path: '/view-restroom/:code',
    name: 'ViewRestroomRecord',
    component: ViewRestroomRecord,
    props: true,
    meta: {
      title: `บันทึก การทำความสะอาดห้องน้ำ`,
    }
  },
  {
    path: '/view-gas-pressure-value/:code',
    name: 'ViewGasPressureValueRecord',
    component: ViewGasPressureValue,
    props: true,
    meta: {
      title: `บันทึก การทำความสะอาดห้องน้ำ`,
    }
  },

  {
    path: '/',
    component: DefaultLayout,
    redirect: 'dashboard',
    meta: {
      requiresAuth: true,
      title: 'หน้าหลัก',
      roles: ['admin', 'manager', 'user'],
    },
    children: [
      {
        path: 'items', // Adjusted to a relative path
        name: 'Items',
        component: () => import('@/views/Items.vue'),
        meta: {
          title: 'รายการ ทั้งหมด',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'items-room-temperature',
        name: 'ItemsRoomTemperature',
        component: () => import('@/views/ItemsRoomTemperaturePage.vue'),
        meta: {
          title: 'รายการห้องควบคุมอุณหภูมิ',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'items-medicine-cabinet',
        name: 'ItemsMedicineCabinet',
        component: () => import('@/views/ItemsMedicineCabinetPage.vue'),
        meta: {
          title: 'รายการอุณหภูมิตู้ยา',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'items-fire-extinguisher',
        name: 'ItemsFireExtinguisher',
        component: () => import('@/views/ItemsFireExtinguisherPage.vue'),
        meta: {
          title: 'รายการตรวจสอบถังดับเพลิง',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'items-restroom',
        name: 'ItemsRestroom',
        component: () => import('@/views/ItemsRestroomPage.vue'),
        meta: {
          title: 'บันทึกการทำความสะอาดห้องน้ำ',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'items-gas',
        name: 'ItemsGas',
        component: () => import('@/views/ItemsGasPage.vue'),
        meta: {
          title: 'รายการบันทึกค่าแก๊ส',
          roles: ['admin', 'manager', 'user'],
        },
      },
 
      {
        path: 'test', // Adjusted to a relative path
        name: 'Test',
        component: () => import('@/views/Test.vue'),
        meta: {
          title: 'Test',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          title: 'หน้าหลัก',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'defibrillator',
        name: 'Defibrillator',
        component: DefibrillatorView,
      },
      {
        path: 'checklists',
        name: 'Checklists',
        component: Checklists,
        meta: {
          title: 'รายการตรวจเช็ค',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'restrooms',
        name: 'Restroom',
        component: Restrooms,
        meta: {
          title: 'ห้องน้ำ',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'cleaning-items',
        name: 'CleaningItems',
        component: CleaningItems,
        meta: {
          title: 'CleaningItems',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'fire-extinguisher',
        name: 'FireExtinguisher',
        component: FireExtinguisher,
        meta: {
          title: 'ถังดับเพลิง',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'fire-extinguisher-items',
        name: 'FireExtinguisherItem',
        component: FireExtinguisherItems,
        meta: {
          title: 'FireExtinguisherItems',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'groups',
        name: 'Groups',
        component: Groups,
        meta: {
          title: 'หน่วยงาน',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'medicine-cabinets',
        name: 'MedicineCabinets',
        component: MedicineCabinets,
        meta: {
          title: 'ตู้แช่ยาและเวชภัณฑ์',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'rooms',
        name: 'Room',
        component: Room,
        meta: {
          title: 'ห้องควบคุมอุณหภูมิ',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'gas-pressure-value',
        name: 'GasPressureValue',
        component: GasPressureValue,
        meta: {
          title: 'ค่าแรงดันแก๊สทางการแพทย์',
          roles: ['admin', 'manager', 'user'],
        },
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
        meta: {
          title: 'ตั้งค่าระบบ',
          roles: ['admin'],
        },
      },
      {
        path: 'admin',
        name: 'Admin',
        component: Admin,
        meta: {
          title: 'Admin',
          roles: ['admin', 'manager', 'user'],
        },
      },

      {
        path: 'docs',
        name: 'Docs',
        component: Docs,
        meta: {
          title: 'Docs',
          roles: ['admin', 'manager', 'user'],
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title || ''} | ${process.env.VUE_APP_NAME_EN}`

  const isAuthenticated = store.getters['isAuthenticated']
  const userRole = store.getters['userRole']

  // ต้อง login
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    return next({ name: 'Login' })
  }

  // ตรวจ role
  if (to.meta.roles && !to.meta.roles.includes(userRole)) {
    return next({ name: 'Dashboard' })
  }

  next()
})

export default router;
